const state = {
  totalProcessingPaid: null,
  collectionSummaryResult: null
}

const getters = {
  getTotalProcessingPaid: (state) => state.totalProcessingPaid,
  getCollectionSummaryResult: (state) => state.collectionSummaryResult
}

const actions = {}

const mutations = {
  setTotalProcessingPaid (state, data) {
    state.totalProcessingPaid = data
  },
  setCollectionSummaryResult (state, data) {
    state.collectionSummaryResult = data
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
